import { type Options } from 'highcharts';
import { createContext, useContext, useId } from 'react';

import { type BuildOptionsFunction, type FlareChart, type FlareProps } from './types';

export type FlareContextType = {
  registerChild: (id: string, buildOptionsFunction: BuildOptionsFunction) => void;
  options: Options | null | undefined;
  parentProps: Omit<FlareProps, 'error'>;
  isLoading: boolean;
  chart?: FlareChart;
  setDisabledSeriesIds?: (disabledSeriesIds: string[]) => void;
  disabledSeriesIds?: string[];
};

const FlareContext = createContext<FlareContextType | null>(null);

export const FlareContextProvider = FlareContext.Provider;

export const useFlareContext = () => {
  const id = useId();
  const context = useContext(FlareContext);

  if (!context) {
    throw new Error('This component must be used within a `<Flare />` component');
  }

  const {
    registerChild,
    parentProps,
    setDisabledSeriesIds,
    disabledSeriesIds,
    options,
    isLoading,
    chart,
  } = context;

  return {
    id,
    registerChild,
    parentProps,
    setDisabledSeriesIds,
    disabledSeriesIds,
    options,
    isLoading,
    chart,
  };
};
